/**
 * @generated SignedSource<<14c7158e5c83300064c6a75760fa767c>>
 * @relayHash 60d473b5467396e551b2cf4c138ad357
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 60d473b5467396e551b2cf4c138ad357

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CreateAccommodationInput = {
  clientMutationId?: string | null;
  registrationId: string;
};
export type accommodationsCreateMutation$variables = {
  input: CreateAccommodationInput;
};
export type accommodationsCreateMutation$data = {
  readonly createAccommodation: {
    readonly accommodation: {
      readonly " $fragmentSpreads": FragmentRefs<"accommodations_accommodation">;
    };
    readonly accommodationEdge: {
      readonly node: {
        readonly id: string;
      } | null;
    };
    readonly registrationId: string;
  } | null;
};
export type accommodationsCreateMutation = {
  response: accommodationsCreateMutation$data;
  variables: accommodationsCreateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "AccommodationEdge",
  "kind": "LinkedField",
  "name": "accommodationEdge",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Accommodation",
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        (v2/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "registrationId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "accommodationsCreateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateAccommodationPayload",
        "kind": "LinkedField",
        "name": "createAccommodation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Accommodation",
            "kind": "LinkedField",
            "name": "accommodation",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "accommodations_accommodation"
              }
            ],
            "storageKey": null
          },
          (v3/*: any*/),
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "accommodationsCreateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateAccommodationPayload",
        "kind": "LinkedField",
        "name": "createAccommodation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Accommodation",
            "kind": "LinkedField",
            "name": "accommodation",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "newStartTime",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "percentTimeExpansion",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "policyExemptions",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Registration",
                "kind": "LinkedField",
                "name": "registration",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "displayName",
                        "storageKey": null
                      },
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v3/*: any*/),
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "60d473b5467396e551b2cf4c138ad357",
    "metadata": {},
    "name": "accommodationsCreateMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "190ad1ca3e13c8f62b9e47e37b6a99d7";

export default node;
